import { render, staticRenderFns } from "./BaseCircleIcon.vue?vue&type=template&id=54ec8871&functional=true&"
import script from "./BaseCircleIcon.vue?vue&type=script&lang=ts&"
export * from "./BaseCircleIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCircleIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports